import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';
import { EditorThemeClasses } from 'lexical';
import { baseTextEditorStyles, baseTextEditorTheme } from './base.css';

export const textareaTheme = {
  ...baseTextEditorTheme,
  root: style([
    baseTextEditorStyles.root,
    {
      backgroundColor: themeVars.controls.background.default,
      borderRadius: borderRadius.r16,
      outline: `1px solid ${themeVars.controls.border.default}`,
      outlineOffset: '-1px',
      padding: `${space.s12}px ${space.s16}px`,

      minHeight: '92px',

      ':focus': {
        outline: `1px solid ${themeVars.controls.border.active}`,
      },
    },
  ]),
} satisfies EditorThemeClasses;
